import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import {
  Cancel,
  DateIcon,
  FileDown,
  SelectUser,
  SingleProfile,
  Users,
} from "../../../styled/AllImages";
import {
  Box,
  ButtonStyled,
  DateInfo,
  FormButtonStyled,
  FormElementWrapper,
  HeadingStyled,
  LabelStyled,
  LazyImage,
  SelectionDropdown,
  SpanStyled,
  SubHeadingStyled,
  TextStyled,
  TextWithIcon,
  TimeInfo,
  UserInfo,
} from "../../../styled/Elements";
import { HistoryModalWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ValidatedInput from "../../../common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import CustomRadioButton from "../../../common/radioButtons/CustomRadio";
import SignupForm from "../../../../pages/auth/signUp/components/SignupForm";
import AddLicenseForm from "../../../../pages/auth/signUp/components/AddLicenseForm";
import PhoneInputField from "../../../common/inputFields/PhoneInput";
import EstablishmentApi from "../../../../services/api/establishmentApi";
import ValidationErrorText from "../../../common/inputFields/ValidationErrorText";
import ContactApi from "../../../../services/api/contactApi";
import { toast } from "react-toastify";
import {
  companySizeOptions,
  roleOptions,
  salesHelpOptions,
} from "../../../../helpers/adminConstants/AdminConstants";
import { useUser } from "../../../../context/userContext";

const ContactSalesModal = ({
  show,
  onHide,
  title,
  createdBy,
  editHistory,
  transferHistory,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const {
    register,
    control,
    reset,
    watch,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  const localizedRoleOptions = roleOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label), // same as label
  }));

  const localizedCompanySizeOptions = companySizeOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label),
  }));

  const localizedSalesHelpOptions = salesHelpOptions.map((opt) => ({
    label: t(opt.label),
    value: t(opt.label),
  }));

  // Helper function to translate options
  const translateOptions = (options, t) =>
    options.map((option) => ({
      label: t(option.label), // Translate the label
      value: option.value,
    }));

  const fetchCountries = async () => {
    try {
      const response = await EstablishmentApi.countyList();
      if (response.status) {
        const countryOptions = response.data.map((country) => ({
          value: country.id,
          label: `${language === "ar" ? country.ar_name : country.en_name} ${
            country.emoji
          }`,
        }));
        setCountries(countryOptions);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (
      !user?.current_organization?.plan_detail?.expired ||
      (user?.current_organization?.plan_detail?.expired &&
        user?.current_organization?.plan_detail?.is_grace_period_active)
    )
      fetchCountries();
  }, [language]);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);
      const { data, code, message } = await ContactApi.contactSalesTeam(
        formData
      );
      if (code === 200) {
        toast.success(message);
        reset();
        onHide();
      } else {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="xl" show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <SelectUserModalWrapper>
          <Box className="">
            <Box className="d-flex justify-content-between align-items-center border-bottom mb-4 p-4">
              <HeadingStyled size="24px" weight="bold" color="var(--text)">
                {t("Contactoursalesteam")}
              </HeadingStyled>
              <Cancel
                className="cursor-pointer"
                style={{ height: "20px", width: "20px" }}
                onClick={onHide}
              />
            </Box>

            <Box className="mb-0 p-4 pb-2 pt-0">
              <Row>
                <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"first_name"}
                    label={"FirstName"}
                    placeholder={"FirstName"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{ required: true }}
                    staric="staric"
                  />
                </Col>
                <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"last_name"}
                    label={"LastName"}
                    placeholder={"Smith"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{ required: true }}
                    staric="staric"
                  />
                </Col>
                <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"email"}
                    label={"WorkEmail"}
                    placeholder={"WorkEmail"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{ required: true }}
                    staric="staric"
                  />
                </Col>
                {/* <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"role"}
                    label={"Role"}
                    placeholder={"Role"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{ required: true }}
                    staric="staric"
                  />
                </Col> */}
                <Col md={12} lg={6}>
                  <Box className="mb-3">
                    <LabelStyled
                      className="labelForm"
                      size="15px"
                      color="var(--text)"
                    >
                      {t("Role")}
                      <span className="staric">*</span>
                    </LabelStyled>
                    <Box className="w-100">
                      <SelectionDropdown
                        name="role"
                        background="white"
                        placeholder={t("Role")}
                        options={localizedRoleOptions}
                        value={watch("role")}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                        }}
                      />
                      {errors.role?.type === "required" && (
                        <ValidationErrorText
                          text={t(errors.role?.message) || t("Pleaseselectone")}
                        />
                      )}
                    </Box>
                  </Box>
                </Col>
                {/* <Col md={12} lg={6}>
                  <FormElementWrapper className="combined p-0 border-0">
                    <Box className="formEleContainer flex-wrap">
                      <LabelStyled className="labelForm w-100">
                        {t("Role")}
                        <span className="staric">*</span>
                      </LabelStyled>
                      <SelectionDropdown
                        name="role"
                        placeholder={t("Select")}
                        options={contactRoleOptionsTrans}
                        background="var(--white)"
                      />
                    </Box>
                  </FormElementWrapper>
                </Col> */}
                {/* <Col lg={12}>
                  <FormElementWrapper className="combined p-0 border-0 mb-3">
                    <Box className="formEleContainer flex-wrap p-0">
                      <LabelStyled className="labelForm w-100">
                        {t("Country")}
                        <span className="staric">*</span>
                      </LabelStyled>
                      <SelectionDropdown
                        name={"type"}
                        placeholder={t("Country")}
                        options={contactSaleCountryTrans}
                        background="var(--white)"
                      />
                    </Box>
                  </FormElementWrapper>
                </Col> */}
                <Col lg={12}>
                  <Box className="mb-3">
                    <LabelStyled
                      className="labelForm"
                      size="15px"
                      color="var(--text)"
                    >
                      {t("Country")}
                      <span className="staric">*</span>
                    </LabelStyled>
                    <Box className="w-100">
                      <SelectionDropdown
                        name="country"
                        className="countryDropdown"
                        background="white"
                        placeholder={t("select_country")}
                        options={countries}
                        value={watch("country")}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                        }}
                      />
                      {errors.country?.type === "required" && (
                        <ValidationErrorText
                          text={
                            t(errors.country?.message) || t("Pleaseselectone")
                          }
                        />
                      )}
                    </Box>
                  </Box>
                </Col>
                <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"company"}
                    label={"Company"}
                    placeholder={"Company"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                    staric="staric"
                  />
                </Col>
                <Col md={12} lg={6}>
                  <Box className="mb-3">
                    <LabelStyled
                      className="labelForm"
                      size="15px"
                      color="var(--text)"
                    >
                      {t("CompanySize")}
                      <span className="staric">*</span>
                    </LabelStyled>
                    <Box className="w-100">
                      <SelectionDropdown
                        name="company_size"
                        background="white"
                        placeholder={t("CompanySize")}
                        options={localizedCompanySizeOptions}
                        value={watch("company_size")}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                        }}
                      />
                      {errors.company_size?.type === "required" && (
                        <ValidationErrorText
                          text={
                            t(errors.company_size?.message) ||
                            t("Pleaseselectone")
                          }
                        />
                      )}
                    </Box>
                  </Box>
                </Col>

                <Col md={12} lg={6}>
                  <PhoneInputField
                    name="phone_number"
                    label={"Phonenumber"}
                    placeholder={"Phonenumber"}
                    register={register}
                    control={control}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                  />
                </Col>
                {/* <Col md={12} lg={6}>
                  <ValidatedInput
                    name={"help_type"}
                    label={"Howcanoursalesteam"}
                    placeholder={"Howcanoursalesteam"}
                    type="input"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                    staric="staric"
                  />
                </Col> */}
                <Col md={12} lg={6}>
                  <Box className="mb-3">
                    <LabelStyled
                      className="labelForm"
                      size="15px"
                      color="var(--text)"
                    >
                      {t("Howcanoursalesteam")}
                      <span className="staric">*</span>
                    </LabelStyled>
                    <Box className="w-100">
                      <SelectionDropdown
                        name="help_type"
                        background="white"
                        placeholder={t("Howcanoursalesteam")}
                        options={localizedSalesHelpOptions}
                        value={watch("help_type")}
                        register={register}
                        errors={errors}
                        validationRules={{
                          required: true,
                        }}
                      />
                      {errors.help_type?.type === "required" && (
                        <ValidationErrorText
                          text={
                            t(errors.help_type?.message) || t("Pleaseselectone")
                          }
                        />
                      )}
                    </Box>
                  </Box>
                </Col>
                <Col lg={12}>
                  <ValidatedInput
                    name={"message"}
                    label={"AnythingElse"}
                    placeholder={"WriteHere"}
                    type="textarea"
                    fieldType="text"
                    className={"mb-3 combined flex-wrap p-0"}
                    bg="var(--white)"
                    register={register}
                    errors={errors}
                    validationRules={{
                      required: false,
                    }}
                    // staric="staric"
                  />
                </Col>
              </Row>
            </Box>
          </Box>
        </SelectUserModalWrapper>
        <Box className="modal-footer">
          <ButtonStyled
            type={"button"}
            label={t("Cancel")}
            onClick={onHide}
            bg="var(--bgSecondary)"
            color="var(--text2)"
          />

          <ButtonStyled
            bg="var(--themeColor)"
            label={t("Submit")}
            isLoading={loading}
            disabled={loading}
            type="submit"
          />
        </Box>
      </Form>
    </Modal>
  );
};

export default ContactSalesModal;

const SelectUserModalWrapper = styled.div`
  .react-datepicker-wrapper {
    input {
      width: 100%;
      color: var(--text);
      font-size: 14px;
      border: none;
      padding-top: 2px;
      cursor: pointer;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
  }
  .rangeIconText .mx-2 {
    margin: 0 !important;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0 0px;
    tr {
      td {
        &:first-child {
          max-width: 200px;
          width: 200px;
        }
        border-bottom: 1px solid var(--borderLight);
        padding: 8px 16px;
        color: var(--text);
        font-size: 14px;
        vertical-align: middle;
      }
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    td {
      border-radius: 0 !important;
    }
  }
`;
